import React from 'react';

import './DefaultedText.scss';

interface DefaultedTextPropsBase {
  val: string | undefined;
  html?: boolean;
  block?: boolean;
  def?: string;
}

type DefaultedTextProps = DefaultedTextPropsBase & React.HTMLAttributes<HTMLElement>;

export function DefaultedText(props: DefaultedTextProps) {
  let { val, html, block, def, ...rest } = props;
  if (!props.val || props.val.length === 0) {
    return (
      <span className="text-smoke italic" {...rest}>
        {props.def || 'None'}
      </span>
    );
  }

  if (props.block) {
    if (props.html) {
      return (
        <div
          className="defaulted-text"
          dangerouslySetInnerHTML={{ __html: props.val }}
          {...rest}
        ></div>
      );
    } else {
      return <div {...rest}>{props.val}</div>;
    }
  }

  if (props.html) {
    return (
      <span
        className="defaulted-text"
        dangerouslySetInnerHTML={{ __html: props.val }}
        {...rest}
      ></span>
    );
  }

  return <span {...rest}>{props.val}</span>;
}
